var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4713 68.25H22.5013C17.3413 68.25 13.4713 66.87 11.0713 64.14C8.67128 61.41 7.74125 57.45 8.37125 52.32L11.0713 29.82C11.8513 23.19 13.5313 17.25 25.2313 17.25H46.8313C58.5013 17.25 60.1813 23.19 60.9913 29.82L63.6913 52.32C64.2913 57.45 63.3913 61.44 60.9913 64.14C58.5013 66.87 54.6613 68.25 49.4713 68.25ZM25.2013 21.75C16.5613 21.75 16.1413 25.17 15.5113 30.33L12.8113 52.83C12.3613 56.64 12.9013 59.43 14.4313 61.14C15.9613 62.85 18.6613 63.72 22.5013 63.72H49.4713C53.3113 63.72 56.0112 62.85 57.5412 61.14C59.0712 59.43 59.6113 56.64 59.1613 52.83L56.4613 30.33C55.8313 25.14 55.4413 21.75 46.7713 21.75H25.2013Z",
    fill: "#0B0F34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 19.5C46.77 19.5 45.75 19.23 45.75 18V13.5C45.75 10.26 43.74 8.25 40.5 8.25H31.5C28.26 8.25 26.25 10.26 26.25 13.5V18C26.25 19.23 25.23 19.5 24 19.5C22.77 19.5 21.75 19.23 21.75 18V13.5C21.75 7.77 25.77 3.75 31.5 3.75H40.5C46.23 3.75 50.25 7.77 50.25 13.5V18C50.25 19.23 49.23 19.5 48 19.5Z",
    fill: "#0B0F34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.57d06356e1c210ce569c3e6d1003c203.svg";
export { ForwardRef as ReactComponent };